import React from "react";
import { ChevronDown, Download } from "lucide-react";
import { Autocomplete, CircularProgress, TextField } from "@mui/material";

function FitrosGiftCardComponents({
    title,
    handleDescargarXlsx,
    compradorDocumento,
    onCompradorDocumentoChange,
    beneficiarioDocumento,
    onBeneficiarioDocumentoChange,
    statusFilter,
    onStatusChange,
    statusOptions = [],

    fechaDesde, setFechaDesde,
    fechaHasta, setFechaHasta,

    usuariosData,
    loadingUsuarios,
    buscarUsuario,
    setBuscarUsuario,
    usuarioSelected,
    setUsuarioSelected
}) {
    const inputBaseClass = "w-full rounded-lg border border-gray-200 bg-[#f1f5f9] px-3 py-2 text-sm text-gray-700 outline-none transition focus:border-blue-200 focus:ring-2 focus:ring-blue-200";
    const autocompleteInputSx = {
        '& .MuiOutlinedInput-root': {
            backgroundColor: '#f1f5f9',
            borderRadius: '0.5rem',
            fontSize: '0.875rem',
        },
    };



    return (
        <div className="rounded-xl border border-gray-200 bg-white p-4 mb-6">
            <div className="mb-3 flex items-center justify-between gap-3">
                <h2 className="text-xl font-bold text-gray-800">{title}</h2>
                <button
                    className="inline-flex items-center justify-center gap-2 rounded-lg bg-emerald-600 px-4 py-2 text-sm font-semibold text-white transition hover:bg-emerald-700"
                    onClick={handleDescargarXlsx}
                >
                    <Download className="w-4 h-4" />
                    Descargar XLSX
                </button>
            </div>

            <div className="grid grid-cols-1 gap-4 md:grid-cols-3">
                {/* <div>
                    <label className="mb-1.5 block text-sm font-semibold text-gray-700">Documento comprador</label>
                    <input
                        type="text"
                        value={compradorDocumento}
                        onChange={(e) => onCompradorDocumentoChange(e.target.value)}
                        placeholder="Ej: 5142795"
                        className={inputBaseClass}
                    />
                </div> */}
                <div>
                    <label className="mb-1.5 block text-sm font-semibold text-gray-700">
                        Desde
                    </label>
                    <input
                        type="date"
                        value={fechaDesde}
                        onChange={(e) => setFechaDesde(e.target.value)}
                        className={inputBaseClass}
                    />
                </div>

                <div>
                    <label className="mb-1.5 block text-sm font-semibold text-gray-700">
                        Hasta
                    </label>
                    <input
                        type="date"
                        value={fechaHasta}
                        onChange={(e) => setFechaHasta(e.target.value)}
                        className={inputBaseClass}
                    />
                </div>

                <div>
                    <label className="mb-1.5 block text-sm font-semibold text-gray-700">
                        Usuario
                    </label>
                    <Autocomplete
                        disablePortal
                        options={usuariosData}
                        sx={{ width: '100%' }}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label="Seleccione"
                                size="small"
                                sx={autocompleteInputSx}
                                InputProps={{
                                    ...params.InputProps,
                                    endAdornment: (
                                        <React.Fragment>
                                            {loadingUsuarios ? <CircularProgress color="inherit" size={20} /> : null}
                                            {params.InputProps.endAdornment}
                                        </React.Fragment>
                                    ),
                                }}
                            />
                        )}
                        onInputChange={(event, newInputValue, reason) => {
                            // if (reason === 'input') handleSorteoSearch(newInputValue);
                            if (reason === 'input') {
                                setBuscarUsuario(newInputValue);
                            }
                        }}
                        // onChange={(e, value) => handleSorteoSelected(value)}
                        onChange={(e, value) => {
                            setUsuarioSelected(value);
                        }}
                        value={usuarioSelected}
                        getOptionLabel={(option) => option?.user?.first_name + ' ' + option?.user?.last_name + '-' + (option?.ci || '')}
                        isOptionEqualToValue={(option, value) => option?.id === value?.id}
                        renderOption={(props, option) => (
                            <li
                                {...props}
                                key={option.id}
                                className="flex items-center justify-between gap-3 rounded-md px-3 py-2 transition-colors hover:bg-slate-100"
                            >
                                <span className="truncate text-sm font-medium text-slate-800">
                                    {option.user?.first_name} {option.user?.last_name}
                                </span>
                                <span className="shrink-0 rounded-full bg-slate-100 px-2 py-0.5 text-xs font-semibold text-slate-600">
                                    CI: {option.ci || "-"}
                                </span>
                            </li>
                        )}
                        loadingText="Cargando..."
                        loading={loadingUsuarios}
                        noOptionsText="No hay opciones"
                    />
                </div>

                {/* <div>
                    <label className="mb-1.5 block text-sm font-semibold text-gray-700">Documento beneficiario</label>
                    <input
                        type="text"
                        value={beneficiarioDocumento}
                        onChange={(e) => onBeneficiarioDocumentoChange(e.target.value)}
                        placeholder="Ej: 5011651"
                        className={inputBaseClass}
                    />
                </div> */}

                {/* <div>
                    <label className="mb-1.5 block text-sm font-semibold text-gray-700">Estado</label>
                    <div className="relative">
                        <select
                            value={statusFilter}
                            onChange={(e) => onStatusChange(e.target.value)}
                            className="appearance-none w-full rounded-lg border border-gray-200 bg-[#f1f5f9] px-3 py-2 pr-8 text-sm text-gray-700 outline-none transition focus:border-blue-200 focus:ring-2 focus:ring-blue-200"
                        >
                            {statusOptions.map((option) => (
                                <option key={option.id} value={option.value}>
                                    {option.label}
                                </option>
                            ))}
                        </select>
                        <ChevronDown className="pointer-events-none absolute right-2 top-1/2 h-4 w-4 -translate-y-1/2 text-gray-400" />
                    </div>
                </div> */}
            </div>
        </div>
    );
}

export default FitrosGiftCardComponents;